import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDumbbell,
  faLeaf,
  faRunning,
  faVolleyballBall,
  faFilm,
  faMotorcycle,
  faUtensils,
  faChessKing,
} from "@fortawesome/free-solid-svg-icons";
const Hobbies = () => {
  const [stats, setStats] = useState(null);
  const [profile, setProfile] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const API_PROFILE = "https://api.chess.com/pub/player/jayk1080";
  const API_STATS = "https://api.chess.com/pub/player/jayk1080/stats";

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [statsRes, profileRes] = await Promise.all([
          fetch(API_STATS),
          fetch(API_PROFILE),
        ]);

        if (statsRes.ok) {
          const statsData = await statsRes.json();
          setStats(statsData);
        }

        if (profileRes.ok) {
          const profileData = await profileRes.json();
          setProfile(profileData);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const hobbyCards = [
    {
      title: "Fitness",
      icon: faDumbbell,
      color: "from-red-500 to-orange-500",
      items: [
        { icon: faDumbbell, text: "Gym", color: "text-red-400" },
        { icon: faLeaf, text: "Yoga", color: "text-green-400" },
        { icon: faVolleyballBall, text: "Sports", color: "text-blue-400" },
        { icon: faRunning, text: "Calisthenics", color: "text-orange-400" },
      ],
    },
    {
      title: "Exploring Joys",
      icon: faMotorcycle,
      color: "from-purple-500 to-indigo-600",
      items: [
        { icon: faFilm, text: "Anime", color: "text-yellow-400" },
        { icon: faMotorcycle, text: "Biking", color: "text-teal-400" },
        { icon: faUtensils, text: "Food", color: "text-red-400" },
      ],
    },
    {
      title: "Chess",
      icon: faChessKing,
      color: "from-amber-500 to-yellow-600",
      items: [],
    },
  ];

  return (
    <div className="bg-gradient-to-br from-[#0f172a] to-[#1e293b] py-12 px-4 sm:px-6 lg:px-8 rounded-2xl shadow-2xl">
      <h2 className="text-4xl font-bold text-[#e2e8f0] pb-6 text-center relative orbitron">
        Hobbies & Interests
        <span className="absolute bottom-4 left-1/2 transform -translate-x-1/2 w-20 h-1 bg-gradient-to-r from-transparent via-[#94a3b8] to-transparent"></span>
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-2">
        {hobbyCards.map((card, index) => (
          <div
            key={index}
            className={`bg-gradient-to-br ${card.color} p-0.5 rounded-2xl transition-all hover:scale-105 hover:shadow-lg`}
          >
            <div className="bg-[#0f172a] rounded-2xl p-6 h-full">
              <div className="flex items-center mb-6">
                <div
                  className={`p-3 rounded-lg bg-gradient-to-br ${card.color} mr-4`}
                >
                  <FontAwesomeIcon
                    icon={card.icon}
                    size="lg"
                    className="text-white"
                  />
                </div>
                <h3 className="text-2xl font-bold text-gray-200 philosopher-6">
                  {card.title}
                </h3>
              </div>

              {card.title !== "Chess" ? (
                <div className="grid grid-cols-2 gap-4">
                  {card.items.map((item, i) => (
                    <div
                      key={i}
                      className="flex flex-col items-center p-3 bg-slate-800/50 rounded-lg"
                    >
                      <FontAwesomeIcon
                        icon={item.icon}
                        size="2x"
                        className={`mb-2 ${item.color}`}
                      />
                      <p className="text-gray-300 font-medium philosopher-6">
                        {item.text}
                      </p>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="space-y-6">
                  {isLoading ? (
                    <div className="animate-pulse flex flex-col items-center">
                      <div className="h-24 w-24 rounded-full bg-slate-700 mb-4"></div>
                      <div className="h-6 w-32 bg-slate-700 rounded mb-2"></div>
                      <div className="h-4 w-24 bg-slate-700 rounded"></div>
                    </div>
                  ) : (
                    <>
                      {profile && (
                        <div className="flex flex-col items-center">
                          <img
                            src={profile.avatar}
                            alt="Profile"
                            className="w-24 h-24 rounded-full border-2 border-amber-400 mb-4 object-cover"
                            loading="lazy"
                          />
                          <span className="text-xl text-gray-200 font-bold philosopher-6">
                            {profile.username}
                          </span>
                          <span className="text-gray-400 philosopher-6">
                            {profile.name}
                          </span>
                        </div>
                      )}

                      {stats && (
                        <div className="mt-4 space-y-3">
                          <div className="flex items-center justify-between bg-slate-800/50 p-3 rounded-lg">
                            <div className="flex items-center">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                version="1.1"
                                x="0"
                                y="0"
                                viewBox="0 0 48 48"
                                className="w-6 h-6"
                              >
                                <g>
                                  <path
                                    d="M24 45.5c10.75 0 19.5-8.75 19.5-19.5 0-10.25-7.95-18.65-18-19.42V5.5H28c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-8c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h2.5v1.08c-10.05.77-18 9.17-18 19.42 0 10.75 8.75 19.5 19.5 19.5zm0-36c9.1 0 16.5 7.4 16.5 16.5S33.1 42.5 24 42.5 7.5 35.1 7.5 26 14.9 9.5 24 9.5z"
                                    fill="#81b64c"
                                    stroke="#81b64c"
                                    stroke-width="2"
                                    opacity="1"
                                    data-original="#000000"
                                  ></path>
                                  <path
                                    d="M24 27.5h8c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-6.5V16c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v10c0 .83.67 1.5 1.5 1.5z"
                                    fill="#81b64c"
                                    stroke="#81b64c"
                                    stroke-width="2"
                                    opacity="1"
                                    data-original="#000000"
                                  ></path>
                                </g>
                              </svg>
                              <span className="text-gray-300 ml-2 philosopher-6">
                                Rapid
                              </span>
                            </div>
                            <div className="text-right">
                              <p className="text-gray-200 font-medium philosopher-6">
                                {stats.chess_rapid?.last?.rating}
                              </p>
                              <p className="text-xs text-gray-400 philosopher-6">
                                Best: {stats.chess_rapid?.best?.rating}
                              </p>
                            </div>
                          </div>

                          <div className="flex items-center justify-between bg-slate-800/50 p-3 rounded-lg">
                            <div className="flex items-center">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 384 512"
                                className="w-6 h-6"
                                fill="#e8a621"
                              >
                                <path d="M0 256L28.5 28c2-16 15.6-28 31.8-28H228.9c15 0 27.1 12.1 27.1 27.1c0 3.2-.6 6.5-1.7 9.5L208 160H347.3c20.2 0 36.7 16.4 36.7 36.7c0 7.4-2.2 14.6-6.4 20.7l-192.2 281c-5.9 8.6-15.6 13.7-25.9 13.7h-2.9c-15.7 0-28.5-12.8-28.5-28.5c0-2.3 .3-4.6 .9-6.9L176 288H32c-17.7 0-32-14.3-32-32z" />
                              </svg>
                              <span className="text-gray-300 ml-2 philosopher-6">
                                Blitz
                              </span>
                            </div>
                            <div className="text-right">
                              <p className="text-gray-200 font-medium philosopher-6">
                                {stats.chess_blitz?.last?.rating}
                              </p>
                              <p className="text-xs text-gray-400 philosopher-6">
                                Best: {stats.chess_blitz?.best?.rating}
                              </p>
                            </div>
                          </div>

                          <div className="flex items-center justify-between bg-slate-800/50 p-3 rounded-lg">
                            <div className="flex items-center">
                              <img
                                src="/assets/bullet.png"
                                alt="bullet"
                                className="w-9 h-8"
                              />
                              <span className="text-gray-300 philosopher-6">
                                Bullet
                              </span>
                            </div>
                            <div className="text-right">
                              <p className="text-gray-200 font-medium philosopher-6">
                                {stats.chess_bullet?.last?.rating}
                              </p>
                              <p className="text-xs text-gray-400 philosopher-6">
                                Best: {stats.chess_bullet?.best?.rating}
                              </p>
                            </div>
                          </div>

                          <div className="flex items-center justify-between bg-slate-800/50 p-3 rounded-lg">
                            <div className="flex items-center">
                              <img
                                src="/assets/daily.png"
                                alt="bullet"
                                className="w-8 h-8"
                              />
                              <span className="text-gray-300 ml-1 philosopher-6">
                                Daily
                              </span>
                            </div>
                            <div className="text-right">
                              <p className="text-gray-200 font-medium philosopher-6">
                                {stats.chess_daily?.last?.rating}
                              </p>
                              <p className="text-xs text-gray-400 philosopher-6">
                                Best: {stats.chess_daily?.best?.rating}
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Hobbies;
